export default "__VITE_ASSET__ycqsRo6p__"